import { atom } from 'nanostores';

export type Dialog =
  | 'about'
  | 'changeOperator'
  | 'clockAdjust'
  | 'codewords'
  | 'docs'
  | 'export'
  | 'scheduledReminders'
  | 'serverSettings'
  | 'connectServer'
  | 'tags'
  | 'template'
  | 'downloadDesktop';

export const $dialog = atom<Dialog | null>(null);

export function openDialog(dialog: Dialog) {
  $dialog.set(dialog);
}

export function closeDialog() {
  $dialog.set(null);
}

export const $tutorial = atom(false);
